import { render, staticRenderFns } from "./AddNewUserFormProjectDetail.vue?vue&type=template&id=6f7f9bd4&scoped=true&"
import script from "./AddNewUserFormProjectDetail.vue?vue&type=script&lang=js&"
export * from "./AddNewUserFormProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddNewUserFormProjectDetail.vue?vue&type=style&index=0&id=6f7f9bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7f9bd4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default})
